// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._ixznlecAM8fpX9ICHQa{grid-column:1/-1}.nC_eXiVZ64f0Vxnj8wzY{background-color:#fbfcfc;padding-bottom:100px}@media(max-width: 767px){.nC_eXiVZ64f0Vxnj8wzY{padding-bottom:28px}}.h21FW9_uA8goUpZrpFq2{overflow:hidden;max-height:100vh}.kqC2bBb7vX_Ob58cdr1S{grid-column:1/-1;margin-bottom:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutBreadcrumbs": "_ixznlecAM8fpX9ICHQa",
	"applicationContainer": "nC_eXiVZ64f0Vxnj8wzY",
	"applicationFixed": "h21FW9_uA8goUpZrpFq2",
	"appointmentHeadingWrap": "kqC2bBb7vX_Ob58cdr1S"
};
export default ___CSS_LOADER_EXPORT___;
